import _ from "lodash";
import {
  Checkbox,
  DatePicker,
  Dialog,
  FlatButton,
  List,
  ListItem,
  RaisedButton,
} from "material-ui";
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreators from "../actions/customapps";
import { getAppTemplate, clearAppTemplateFromStore } from "../actions/apps";
import Title from "../components/common/Title";
import stretch from "../resources/icons/stretch.png";
import trophy from "../resources/icons/trophy.png";
import GoalFlag from "../resources/icons/goal_flag.png";
import TimelineIcon from "material-ui/svg-icons/action/timeline";
import trophyWithRibbon from "../resources/icons/trophy_with_ribbon.png";
import colors from "../styles/colors";
import layout from "../styles/layout";
import AppFrame from "./AppFrame";
import userActivityService from "../services/userActivity";
import { Mixpanel } from "../mixpanel";
import InstructionListItem from "../components/common/InstructionListItem";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import events from "../services/events";

import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const style = {
  pointsEarnedLable: {
    color: colors.text,
    textAlign: "right",
    fontSize: 20,
    fontWeight: 900,
  },
  prosgressContainer: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 20,
    marginBottom: 20,
  },
  progressContainerItem: {
    flex: "1",
  },
  instructionItem: {
    background: "#FFFFFF",
    borderBottom: "1px solid #E5E5E5",
  },
  button: {
    width: 170,
    border: "2px solid grey",
    borderRadius: 8,
    padding: 4,
    marginRight: 4,
    marginLeft: 4,
  },
  buttonImage: {
    width: 24,
    height: 24,
    padding: 5,
    margin: 0,
    border: "2px solid #52829D",
    borderRadius: 18,
  },
  dateField: {
    maxWidth: 150,
    fontSize: 16,
    fontWeight: 600,
    height: 35,
  },
  pointsEarnedDialog: {
    maxWidth: 400,
    alignItems: "center",
  },
  pointsEarnedImageContainer: {
    borderStyle: "solid",
    borderColor: colors.steelBlue,
    backgroundColor: "white",
    borderWidth: 2,
    padding: 0,
    borderRadius: 40,
    width: 47,
    height: 47,
    margin: 2,
    marginTop: 5,
  },
  pointsCollectedTrophy: {
    width: 47,
    height: 47,
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
  },
  modalHeader: {
    background: colors.primary,
    textAlign: "center",
    color: colors.white,
    fontWeight: "900",
  },
};

class PatientDashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userId: props.match.params.userId,
      appId: props.match.params.appId,
      customAppId: props.match.params.customAppId,
      customApp: {},
      width: 0,
      height: 0,
      instruction: {},
      userActivities: [],
      selectedDate: new Date(),
      selectedActivitiesForPoints: [],
      activityDate: new Date(),
      showInstructionPopup: false,
      isCollectPointsDialogOpen: false,
      isPointsEarnedDialogOpen: false,
      isLibraryOnly: props.match.params.type !== "Standard",
      searchText: "",
      canSearchByGroup: false,
      programInstructions: [],
    };

    this.renderProgramInstructions = this.renderProgramInstructions.bind(this);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener(
      "resize",
      this.updateWindowDimensions.bind(this)
    );

    this.props.clearAppTemplateFromStore();
  }

  componentWillMount() {
    if (!this.state.isLibraryOnly) {
      this.props.fetchCustomApp(this.state.appId, this.state.userId);
    } else {
      this.props.getAppTemplate(this.state.userId, this.state.appId, 100);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.state.userId &&
      this.state.appId &&
      _.isEmpty(this.state.customApp) &&
      !_.isEmpty(nextProps.customapps.customApps[this.state.appId])
    ) {
      const customApps = nextProps.customapps.customApps[this.state.appId];
      this.setState({
        customApp: customApps[this.state.userId],
        isLibraryOnly: false,
      });
      this.props.getUserActivityForCustomApp(
        this.state.userId,
        customApps[this.state.userId].customAppId
      );
    }

    if (
      nextProps.appTemplates &&
      this.state.isLibraryOnly &&
      nextProps.appTemplates[this.state.appId]
    ) {
      let capp = this.state.customApp;
      capp.categories = [];
      //grab all the categories off the app.app_template attribute and append it as the current custom app.
      nextProps.appTemplates[this.state.appId].groups.map((g) => {
        let cats = g.categories.map((cat) => {
          cat.groupName = g.groupName;
          return cat;
        });
        capp.categories = capp.categories.concat(cats);
        return true;
      });

      this.setState({ customApp: capp });
    }

    if (nextProps.customapps.userActivity) {
      this.setState({ userActivities: nextProps.customapps.userActivity });
    }

    if (nextProps.customapps && nextProps.customapps.programInstructions) {
      this.setState({
        programInstructions: nextProps.customapps.programInstructions,
      });
    }
  }

  renderInstructions() {
    let filteredInstructions = _.values(this.state.customApp.categories);

    const q = this.state.searchText.toLowerCase();
    if (this.state.canSearchByGroup) {
      filteredInstructions = filteredInstructions.filter((instr) =>
        ((instr.groupName || "").toLowerCase()).includes(q)
      );
    } else {
      filteredInstructions = filteredInstructions.filter((instr) =>
        instr.categoryName
          .toLowerCase()
          .includes(q)
      );
    }

    return (
      <List>
        {filteredInstructions
          .filter((instruction) => !!instruction.archived === false)
          .map((instruction) => (
            <InstructionListItem
              {...instruction}
              onClick={() => {
                this.openInstruction(instruction);
              }}
              isLibrary={this.state.isLibraryOnly}
            />
          ))}
        {filteredInstructions
          .filter((instruction) => !!instruction.archived === true)
          .map((instruction) => (
            <InstructionListItem
              {...instruction}
              onClick={() => {
                this.openInstruction(instruction);
              }}
              isLibrary={this.state.isLibraryOnly}
            />
          ))}
      </List>
    );
  }

  renderUserActivities() {
    const filteredActivities = this.state.userActivities.filter((act) => {
      return (
        this.formatDate(act.activityDate) ==
        this.formatDate(this.state.selectedDate)
      );
    });

    if (filteredActivities.length < 1) {
      return <p>No activity on this day.</p>;
    } else {
      return (
        <List>
          {filteredActivities.map((activity) => {
            return (
              <ListItem
                primaryText={activity.instructionName}
                style={style.instructionItem}
              />
            );
          })}
        </List>
      );
    }
  }

  openInstruction(instruction) {
    const path = window.location.pathname.split("/");

    if (path[4] === "LibraryOnly") {
      events().trackUserEvent(
        "View Instruction Detail",
        path[2],
        null,
        instruction.categoryId,
        null,
        this.state.userId,
        null,
        "portal",
        path[5],
        instruction.categoryName,
        null
      );
    } else {
      events().trackUserEvent(
        "View Instruction Detail",
        this.state.appId,
        this.state.customAppId,
        instruction.categoryId,
        null,
        this.state.userId,
        null,
        "portal",
        this.state.customApp.appInfo.appName,
        instruction.categoryName,
        null
      );
    }

    this.props.history.push({
      pathname: `/patient-instruction-view/${this.state.appId}/${this.state.userId}`,
      state: { instruction: instruction },
    });
  }

  renderGoal() {
    return (
      <div>
        <p style={layout.common.subHeading}>
          Patient Goal -- {this.state.customApp.goals[0].startDate} //{" "}
          {this.state.customApp.goals[0].endDate}
        </p>
        <p style={layout.common.text}>
          {this.state.customApp.goals[0].goal
            ? this.state.customApp.goals[0].goal
            : "No Goal Stated"}
        </p>
      </div>
    );
  }

  handleOpenCollectPoints = () => {
    this.setState({ isCollectPointsDialogOpen: true });
  };

  handleCloseCollectPoints = () => {
    this.setState({
      isCollectPointsDialogOpen: false,
      selectedActivitiesForPoints: [],
    });
  };

  handleSelectInstructionForPoints = (event, isChecked) => {
    let activities = this.state.selectedActivitiesForPoints;
    const selectedActivity = {
      activityId: event.target.id,
      activityName: event.target.name,
    };

    if (isChecked) {
      activities.push(selectedActivity);
    } else {
      activities = activities.filter(
        (item) => item.activityId !== selectedActivity.activityId
      );
    }
    this.setState({ selectedActivitiesForPoints: activities });
  };

  handleActivityDateChanged = (event, date) => {
    this.setState({ activityDate: date });
  };

  submitUserActitivity = () => {
    userActivityService()
      .addUserActivity(
        this.state.userId,
        this.state.customApp.customAppId,
        this.state.activityDate.getTime(),
        this.state.selectedActivitiesForPoints
      )
      .then((resp) => {
        this.props.getUserActivityForCustomApp(
          this.state.userId,
          this.state.customApp.customAppId
        );

        this.props.fetchCustomApp(this.state.appId, this.state.userId);

        let updateApp = this.state.customApp;
        updateApp.points =
          updateApp.points +
          this.state.selectedActivitiesForPoints.length * 100;
        this.setState({
          isCollectPointsDialogOpen: false,
          selectedActivitiesForPoints: [],
          isPointsEarnedDialogOpen: true,
          ptsEarned: this.state.selectedActivitiesForPoints.length * 100,
          customApp: updateApp,
        });
        setTimeout(() => {
          this.setState({ isPointsEarnedDialogOpen: false, ptsEarned: 0 });
        }, 3000);
      });
    Mixpanel.track("Log Activity", {
      "Patient ID": this.state.userId,
      "Channel ID": this.state.customApp.customAppId,
      "Acivity Date": this.state.activityDate.getTime(),
      "Instruction ID": this.state.selectedActivitiesForPoints,
      Platform: "Web",
    });

    //Log user did it event for each selected activity
    this.state.selectedActivitiesForPoints.map((activity) => {
      events().trackUserEvent(
        "Log Activity",
        this.state.appId,
        this.state.customAppId,
        activity.activityId,
        null,
        this.state.userId,
        null,
        "portal",
        this.state.customApp.appName,
        activity.activityName,
        null
      );
      return true;
    });
  };

  renderCollectPointsDialog() {
    return (
      <div>
        <Dialog
          titleStyle={style.modalHeader}
          contentStyle={{ maxWidth: 500 }}
          title="Log Activity"
          actions={[
            <FlatButton
              label="Cancel"
              primary={true}
              onClick={this.handleCloseCollectPoints}
            />,
            <FlatButton
              label="Log Activity"
              primary={true}
              disabled={this.state.selectedActivitiesForPoints.length < 1}
              onClick={this.submitUserActitivity}
              labelStyle={{ fontWeight: "bold" }}
            />,
          ]}
          modal={true}
          open={this.state.isCollectPointsDialogOpen}
          onRequestClose={this.handleCloseCollectPoints}
          autoScrollBodyContent={true}
        >
          <div>
            <div>
              <p style={{ ...layout.common.label }}>Date of Activity</p>
              <DatePicker
                defaultDate={this.state.activityDate}
                maxDate={new Date()}
                onChange={this.handleActivityDateChanged}
                textFieldStyle={style.dateField}
              />
            </div>

            <div style={{ marginTop: 8, marginBottom: 8 }}>
              {_.values(this.state.customApp.categories).map((instruction) => (
                <Checkbox
                  id={instruction.categoryId}
                  name={instruction.categoryName}
                  label={instruction.categoryName}
                  style={{ marginTop: 5 }}
                  onCheck={this.handleSelectInstructionForPoints}
                />
              ))}
            </div>
          </div>
        </Dialog>
      </div>
    );
  }

  renderPointsEarnedDialog() {
    return (
      <Dialog
        open={this.state.isPointsEarnedDialogOpen}
        modal={false}
        contentStyle={style.pointsEearnedDialog}
        onRequestClose={() => {
          this.setState({ isPointsEarnedDialogOpen: false });
        }}
      >
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div style={style.pointsEarnedImageContainer}>
            <img src={trophyWithRibbon} style={style.pointsCollectedTrophy} />
          </div>
          <p
            style={{ ...style.pointsEarnedLable, fontSize: 17, marginLeft: 8 }}
          >
            You've earned{" "}
            <span style={{ color: colors.orange, fontSize: 20 }}>
              +{this.state.ptsEarned}
            </span>{" "}
            points!
          </p>
        </div>
      </Dialog>
    );
  }

  renderSearchBar() {
    return (
      <div style={{ ...layout.common.filterRow, justifyContent: "start" }}>
        <div style={layout.common.searchField}>
          <TextField
            id="filled-full-width"
            label="Search"
            style={{ margin: 8 }}
            placeholder={
              this.state.canSearchByGroup
                ? "Search By Category"
                : "Search By Name"
            }
            fullWidth
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
            variant="outlined"
            value={this.state.searchText}
            onChange={(e) => {
              this.setState({ searchText: e.target.value });
            }}
          />
          <IconButton
            color="primary"
            aria-label="Clear Search"
            component="span"
            onClick={() => this.setState({ searchText: "" })}
            style={layout.common.searchFieldCancel}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <FormControlLabel
          control={
            <Switch
              checked={this.state.canSearchByGroup}
              onChange={(val) => {
                const curVal = this.state.canSearchByGroup;
                this.setState({ canSearchByGroup: !curVal });
              }}
              name="toggleByCategory"
              color="primary"
            />
          }
          label="Search By Category"
        />
      </div>
    );
  }
  renderProgramInstructions() {
    if (
      this.state.programInstructions &&
      this.state.programInstructions.length > 0
    ) {
      let lastProgramName = "";
      let programs = [];
      let instructions = [];
      this.state.programInstructions.map((i) => {
        if (i.programName !== lastProgramName) {
          if (lastProgramName !== "") {
            //IF not the first time the program name switched, dump the array into a new var
            programs.push({ name: lastProgramName, instructions });
            instructions = [];
          }
        }
        lastProgramName = i.programName;
        instructions.push(i);

        return null;
      });
      //Pick up the last array
      programs.push({ name: lastProgramName, instructions });

      return (
        <div>
          <div
            style={{
              ...layout.common.subHeading,
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <h4>Assigned Programs</h4>
          </div>
          {programs.map((p) => {
            return (
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon style={{ color: "white" }} />}
                  style={{ backgroundColor: colors.primary, color: "white" }}
                >
                  {p.name}
                </AccordionSummary>
                <AccordionDetails>
                  <div style={{ flexDirection: "column", flex: 1 }}>
                    {p.instructions.map((instruction) => {
                      return (
                        <InstructionListItem
                          {...instruction}
                          onClick={() => {
                            this.openInstruction(instruction);
                          }}
                          isLibrary={this.state.isLibraryOnly}
                        />
                      );
                    })}
                  </div>
                </AccordionDetails>
              </Accordion>
            );
          })}
        </div>
      );
    } else {
      return null;
    }
  }

  render() {
    let targetDevice = "desktop";
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      targetDevice = "mobile";
    }

    return (
      <AppFrame auth={this.props.auth} targetDevice={targetDevice}>
        <div style={layout.common.page}>
          <Title
            text2={
              this.state.customApp &&
              this.state.customApp.appInfo &&
              this.state.customApp.appInfo.appName
            }
            goBack={() => this.props.history.goBack()}
          />

          <div style={layout.common.mainContainer}>
            {!this.state.isLibraryOnly && (
              <div>
                <p style={style.pointsEarnedLable}>
                  <span style={{ color: colors.orange }}>
                    +{this.state.customApp.points}
                  </span>{" "}
                  Total Points Earned
                </p>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-end",
                    flexWrap: "wrap",
                  }}
                >
                  <RaisedButton
                    label="See Progress"
                    icon={<TimelineIcon />}
                    style={style.button}
                    onClick={() => {
                      let link = `/patient-progress/${this.state.appId}/${this.state.userId}`;

                      events().trackUserEvent(
                        "View Activities",
                        this.state.appId,
                        this.state.customAppId,
                        null,
                        null,
                        this.state.userId,
                        null,
                        "portal",
                        this.state.customApp.appInfo.appName,
                        null,
                        null
                      );

                      this.props.history.push(link);
                    }}
                  />
                  <RaisedButton
                    label="See Awards"
                    icon={<img src={trophy} style={style.buttonImage} />}
                    style={style.button}
                    onClick={() => {
                      let link = `/patient-awards/${this.state.appId}/${this.state.userId}`;

                      events().trackUserEvent(
                        "View Awards",
                        this.state.appId,
                        this.state.customAppId,
                        null,
                        null,
                        this.state.userId,
                        null,
                        "portal",
                        this.state.customApp.appInfo.appName,
                        null,
                        null
                      );
                      this.props.history.push(link);
                    }}
                  />
                  <RaisedButton
                    label="Log Activity"
                    icon={<img src={stretch} style={style.buttonImage} />}
                    style={style.button}
                    onClick={() => {
                      this.handleOpenCollectPoints();
                    }}
                  />
                  <RaisedButton
                    label="Goal"
                    icon={<img src={GoalFlag} style={style.buttonImage} />}
                    style={style.button}
                    onClick={() => {
                      let link = `/custom-app-goal/${this.state.appId}/${this.state.userId}`;

                      events().trackUserEvent(
                        "View Goal",
                        this.state.appId,
                        this.state.customAppId,
                        null,
                        null,
                        this.state.userId,
                        null,
                        "portal",
                        this.state.customApp.appInfo.appName,
                        null,
                        null
                      );
                      this.props.history.push(link);
                    }}
                  />
                </div>
                {this.state.customApp.goals &&
                  this.state.customApp.goals[0] &&
                  this.renderGoal()}
                <br />
              </div>
            )}

            {this.renderSearchBar()}
            {this.renderProgramInstructions()}
            <p style={layout.common.subHeading}>Instructions</p>
            {!_.isEmpty(this.state.customApp) && this.renderInstructions()}
          </div>
        </div>
        {this.renderCollectPointsDialog()}
        {this.renderPointsEarnedDialog()}
      </AppFrame>
    );
  }
}

function mapStateToProps({ user, customapps, apps }) {
  return {
    user,
    customapps,
    appTemplates: apps.appTemplates,
  };
}

function mapDispatchToProps(dispatch) {
  let allActions = {
    ...actionCreators,
    getAppTemplate,
    clearAppTemplateFromStore,
  };
  return bindActionCreators(allActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PatientDashboard);



// WEBPACK FOOTER //
// ./src/layout/PatientDashboard.js